module.exports = __webpack_public_path__ + "static/img/15.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/15.png
// module id = ymsb
// module chunks = 0